<template>
  <div class="mt-4">
    <div class="mb-2" v-show="registerErrorMsg">
      <error :errors="registerErrors">
        <span v-html="registerErrorMsg"></span>
      </error>
    </div>

    <!-- is Private -->
    <input name="company_private" type="hidden" id="company_private" value="2">

    <div class="space-y-2">
      <!-- Salutation -->
      <div class="flex space-x-4">
        <input-radio
          name="register_salutation"
          id="register_salutation_mr"
          :input-value="lang.labels.mr"
          :label="lang.labels.mr"
          v-model="register_salutation"
        ></input-radio>

        <input-radio
          name="register_salutation"
          id="register_salutation_mrs"
          :input-value="lang.labels.mrs"
          :label="lang.labels.mrs"
          v-model="register_salutation"
        ></input-radio>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <!-- first name -->
        <input-text
          name="register_first_name"
          id="register_first_name"
          :required="true"
          :label="lang.labels.first_name"
          v-model="register_first_name"
          :error="registerErrors.first_name !== undefined"
        ></input-text>

        <!-- last name -->
        <input-text
          name="register_last_name"
          id="register_last_name"
          :required="true"
          :label="lang.labels.last_name"
          v-model="register_last_name"
          :error="registerErrors.last_name !== undefined"
        ></input-text>
      </div>

      <!-- email -->
      <input-text
        name="register_email"
        id="register_email"
        type="email"
        :label="lang.labels.email"
        :required="true"
        v-model="register_email"
        :error="registerErrors.email !== undefined"
      ></input-text>

      <!-- Newsletter -->
      <input-checkbox
        name="register_newsletter"
        id="register_newsletter"
        input-value="1"
        v-model="register_newsletter"
      >{{ lang.labels.register_receive_newsletter }}</input-checkbox>

      <!-- T&C -->
      <input-checkbox
        name="register_tnc"
        id="register_tnc"
        input-value="1"
        :required="true"
        v-model="register_tnc"
        :error="registerErrors.tnc !== undefined"
      ><span v-html="lang.labels.register_accept_tnc"></span></input-checkbox>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import axios from 'axios';
import InputText from "../inputs/InputText.vue";
import InputRadio from "../inputs/InputRadio.vue";
import InputCheckbox from "../inputs/InputCheckbox.vue";
import Error from "../alerts/Error.vue";

const props = defineProps({
  lang: Object,
});

const emit = defineEmits(['success']);

const register_salutation = ref(props.lang.labels.mrs);
const register_first_name = ref("");
const register_last_name = ref("");
const register_email = ref("");
const register_newsletter = ref("");
const register_tnc = ref(0);
const registerErrors = ref({});
const registerErrorMsg = ref("");

const isValid = computed(() => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return register_first_name.value.trim() !== ""
    && register_last_name.value.trim() !== ""
    && emailPattern.test(register_email.value.trim())
    && register_tnc.value === 1;
});

const register = () => {
  registerErrorMsg.value = "";
  registerErrors.value = {};

  return axios
    .post(`/web-api/register`, {
      salutation: register_salutation.value,
      first_name: register_first_name.value,
      last_name: register_last_name.value,
      email: register_email.value,
      newsletter: register_newsletter.value,
      tnc: register_tnc.value,
    })
    .then((response) => {
      if (response.data.csrf_token) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrf_token;
        document.querySelector('meta[name="csrf-token"]').setAttribute('content', response.data.csrf_token);
      }
      emit('success', 'register');
      return response;
    })
    .catch((error) => {
      registerErrorMsg.value = props.lang.errors.fillMandatory;
      registerErrors.value = error.response?.data?.errors ?? {};
      throw error;
    });
};

defineExpose({
  register,
  isValid,
});
</script>
